import { ContainerModule } from "inversify";

import { OrganizationProfileRepository } from "../application/store/organization-profile.repository";
import { FakeOrganizationProfileRepository } from "./store/in-mem-organization-profile.repository";
import { RestOrganizationProfileRepository } from "./store/rest-organization-profile.repository";

export const OrganizationProfileModule = new ContainerModule(({ bind }) => {
  bind(OrganizationProfileRepository).toDynamicValue(() => {
    return process.env.NEXT_PUBLIC_USE_FAKE_IMPLEMENTATIONS === "true"
      ? new FakeOrganizationProfileRepository()
      : new RestOrganizationProfileRepository();
  });
});
